import React from "react"
import { ArrowRight, Calendar, FileText, Newspaper } from "lucide-react"
import { SectionHeading } from "./ui/SectionHeading"
import { OFFER_PDF_URL } from "../data/products"

/**
 * Article teaser (see data.json → Articles). Full articles are static pages in public/clanky/.
 */
export interface ArticleItem {
	title: string
	excerpt: string
	url: string
	date?: string
	tag?: string
}

interface ArticlesProps {
	data?: ArticleItem[]
}

/**
 * Articles Component — teaser list linking to the static article pages.
 * Mirrors the static "#articles" section in public/index.html.
 */
export const Articles: React.FC<ArticlesProps> = ({ data }) => {
	if (!data || data.length === 0) return null

	return (
		<section id="articles" className="lp-section lp-section--soft lp-section--dots">
			<div className="lp-container">
				<SectionHeading
					eyebrow="Blog"
					title="Články a know-how"
					lead="Píšeme o tom, co řešíme s klienty: integrace systémů, automatizace a AI s návratností, kterou lze změřit."
				/>

				<div className="lp-grid lp-grid--3">
					{data.map((item, idx) => (
						<article
							key={item.url}
							className="lp-card lp-card--bar lp-article"
							data-reveal=""
							style={{ "--reveal-delay": `${idx * 100}ms` } as React.CSSProperties}
						>
							{(item.date || item.tag) && (
								<div className="lp-article__meta">
									{item.tag && <span className="lp-tag">{item.tag}</span>}
									{item.date && (
										<span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
											<Calendar size={14} /> {item.date}
										</span>
									)}
								</div>
							)}
							<h3 className="lp-article__title">
								<a href={item.url}>{item.title}</a>
							</h3>
							<p className="lp-card__text">{item.excerpt}</p>
							<a href={item.url} className="lp-article__read">
								Přečíst článek <ArrowRight size={16} />
							</a>
						</article>
					))}
				</div>

				<div className="lp-article__links" data-reveal="">
					<a href="/clanky/" className="lp-btn lp-btn--outline">
						<Newspaper size={18} /> Všechny články
					</a>
					<a href="/docs/b2b_integrace_zaklady.pdf" className="lp-btn lp-btn--outline">
						<FileText size={18} /> Stáhnout PDF Základy integrace B2B
					</a>
					<a href={OFFER_PDF_URL} target="_blank" rel="noopener noreferrer" className="lp-btn lp-btn--outline">
						<FileText size={18} /> Nabídka řešení: Automatizační ekosystém (PDF)
					</a>
				</div>
			</div>
		</section>
	)
}
